import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import ThemeTable from '@shared/components/themeTable'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import { RightBracketArrow } from '@shared/components/ctIcons'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import styles from './style.module.scss'
import useWindowSize from '@shared/hooks/windowSize'
const CustomLink = dynamic(() => import('@shared/components/customLink'))

const RecentForm = ({ recentFormData, playerData }) => {
  const recentFormLabels = playerData?.sPlayingRole === 'all' ? [
    'Opponent',
    'Format',
    'Bat',
    'Bowl'
  ] : [
    'Opponent',
    'Format',
    playerData?.sPlayingRole
  ]

  const [width] = useWindowSize()
  return (
    <section className={`${styles.recentForm} content-visibility-auto text-center mb-3 mb-md-4`}>
      <h3 className='small-head text-start'>Recent Form</h3>
      <ThemeTable labels={recentFormLabels}>
        {
          recentFormData.slice(0, 3).map((element) => {
            return (
              <>
                <tr key={`${element?.oMatchPerformance?.sBlowerScore}-${element?.oMatchPerformance?.sBatterScore}`}>
                  <td>
                    <div className={styles.opponent}>
                      <MyImage
                        src={getImgURL(element.oMatch.oTeamScoreA.oTeam.oImg.sUrl) || noImage}
                        alt={element.oMatch.oTeamScoreA.oTeam.sTitle}
                        placeholder='blur'
                        blurDataURL={BLUR_DATA_URL_BASE64}
                        height='24'
                        width='24'
                        layout='responsive'
                        sizes='(max-width: 767px) 20px, (max-width: 991px) 20px, (max-width: 1190px) 20px, 20px'
                      />
                      {width < 575 ? <>  {element.oMatch.oTeamScoreA.oTeam.sAbbr}</> : <>
                      {element.oMatch.oTeamScoreA.oTeam.sTitle}
                            </>}
                    </div>
                  </td>
                  <td className={styles.format}>{element.oMatch.sFormatStr}</td>
                  <td>
                    {
                      playerData?.sPlayingRole === 'bowl' ? (element?.oMatchPerformance?.sBlowerScore || '-') : (element?.oMatchPerformance?.sBatterScore || '-')
                    }
                  </td>
                  {
                    playerData?.sPlayingRole === 'all' && (
                      <td>
                        {
                          playerData?.sPlayingRole === 'all' && (element?.oMatchPerformance?.sBlowerScore || '-')
                        }
                      </td>
                    )
                  }
                </tr>
              </>
            )
          })
        }
        <tr>
          <td></td>
          <td></td>
          {playerData?.sPlayingRole === 'all' && <td></td>}
          <td className={`${styles.viewFull} theme-text`}>
            <CustomLink className='theme-text' href={`/${playerData?.oSeo?.sSlug}/match`}>All Matches</CustomLink>
            <RightBracketArrow />
          </td>
        </tr>
      </ThemeTable>
    </section>
  )
}

RecentForm.propTypes = {
  playerData: PropTypes.object,
  recentFormData: PropTypes.array
}

export default RecentForm
